/**
 * Asynchronously loads the component for DocumentPage
 */

import * as React from 'react';
import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const ResponsePage = lazyLoad(
  () => import('./ResponsePrefiller'),
  module => module.Prefiller,
  {
    fallback: <LoadingIndicator />,
  },
);
